import { useEffect, useState, useMemo, useCallback} from "react";
import {Col} from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APISD } from "../../../../../config/apisd";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardUser } from '@fortawesome/free-solid-svg-icons';
import ToastError from "../../../../NotificationToast/ToastError";
import { PulseLoader } from "react-spinners";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import LogAbsen from "./subpage/log_absensi/Home";
import AksesAbsen from "./subpage/akses_absen/Home";
import KonfigurasiAbsen from "./subpage/konfigurasi_absensi/Home";
import PengaturanJam from "./subpage/pengaturan_jam/Home";
import KoreksiAbsen from "./subpage/koreksi_absen/Home";

export default function Absensi() {
  document.title = "Absensi";

  const [getData, setGetData] = useState([]);
  const ascending = 1;

  const token = localStorage.getItem("token");

  // Responsive
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  // Search frontend
  const [searchKeyword, setSearchKeyword] = useState("");

  // Pagination frontend
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // UI state
  const [isFetching, setIsFetching] = useState(false);
  
  // modal update
  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();
  
  // modal add
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();
  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];
    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(item => item.menu?.url === location.pathname);
      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    setSearchKeyword("");
    setIsFetching(true);

    try {
      const response = await APISD.get(
        `/api/absen-logs?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetData(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data",
      });
    } finally {
      setIsFetching(false);
    }
  }, [ascending, fetchParams]);

  useEffect(() => {
    GetResponseData();
  }, [GetResponseData]);



  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  // =========================
  // FILTER SEARCH FRONTEND
  // =========================
  const filteredData = useMemo(() => {
    const q = (searchKeyword || "").trim().toLowerCase();

    const base = !q
      ? getData || []
      : (getData || []).filter((item) => {
          const label = (item?.stages || "").toString().toLowerCase();
          const namaJenjang = (item?.stages_name || "").toString().toLowerCase();

          return (
            label.includes(q) ||
            namaJenjang.includes(q) 
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.stages_name || "").toString().trim(),
        (b?.stages_name || "").toString().trim()
      )
    );
  }, [getData, searchKeyword, nameCollator]);

  // =========================
  // FRONTEND PAGINATION
  // =========================
  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");
    for (let i = left; i <= right; i++) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }
    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter((v, idx, arr) => arr.indexOf(v) === idx);
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const p = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);
    setTablePage(p);
  };


  return (
    <div className="body" >

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          {isTabletOrMobile ? (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faClipboardUser} />
                </span>
                <h4 className="page-title-text"> Data Absensi</h4>
              </div>

            </>
          ) : (
            <>
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faClipboardUser} />
                </span>
                <h4 className="page-title-text"> Data Absensi </h4>
              </div>
            </>
          )}
        </div>
      </div>
      

      <div className="body-content">

         {isFetching && (
                <div className="text-center" style={{ padding: "10px 0" }}>
                  <span style={{ color: "#2e52aeff", fontWeight: "500" }}>
                    <PulseLoader color={"#3f5bea"} size={12} />
                  </span>
                </div>
              )}
        
        {!isFetching && (
          <Tabs defaultActiveKey="home" id="uncontrolled-tab-example"className="mb-3 nav-tabs">

            <Tab eventKey="home" title="Akses Absensi" className="nav-item">
              <AksesAbsen/>
            </Tab>

            <Tab eventKey="barcode" title="Barcode">
               <KonfigurasiAbsen />
            </Tab>

            <Tab eventKey="setting-jam" title="Pengaturan Jam">
               <PengaturanJam />
            </Tab>

             <Tab eventKey="profile" title="Log Absensi">
                <LogAbsen />
            </Tab>

            <Tab eventKey="koreksi-absen" title="Koreksi Absensi">
               <KoreksiAbsen />
            </Tab>

          </Tabs>

        )} 

      </div>
    </div>
   );



}
